import apiFetch from '../apiFetch'

export default function (token, filter) {
  return apiFetch({ endPoint: 'OrganizedUnit/GetAll', method: 'POST', body: filter, token: token })
}
